export enum ParentKey {
  PARENTS = 'parents',
  STUDENT_PARENTS = 'studentParents',
  PARENT_CHILDREN = 'parentChildren',
  MY_CHILDREN = 'myChildren',
  CALENDAR = 'parentCalendar',
  CHILD_SCHEDULE = 'childSchedule',
  CHILD_GRADES = 'childGrades',
  CHILD_ATTENDANCE = 'childAttendance',
  CHILD_ATTENDANCE_SUMMARY = 'childAttendanceSummary',
  CHILD_GROUPS = 'childGroups',
  CHILD_QUIZZES = 'childQuizzes',
  CHILD_QUIZ_ATTEMPT = 'childQuizAttempt',
  CHILD_ASSIGNMENTS = 'childAssignments',
  CHILD_ASSIGNMENT = 'childAssignment',
  CHILD_TEACHERS = 'childTeachers',
}
